import React from 'react';

import { FieldError } from '#/common/components';
import { Avatar, AvatarFallback, AvatarImage, Button, Card, CardContent, Input, Label } from '#/components/ui';
import { ChangePassword } from './ChangePassword';
import { useProfile } from '../hooks/useProfile';

const Profile = () => {
    const {
        handleChangeProfile,
        handleSubmitProfile,
        profileErrors,
        profileTouched,
        profileValues,
        updateProfileApiLoading,
        handleImage,
        handleDeleteImage,
        imagePreview,
        isChangePassword,
        handleChangePassword,
        setIsChangePassword,
    } = useProfile();

    return (
        <div className='min-h-[calc(100dvh-235px)] flex flex-col items-center justify-center'>
            <div className='w-full flex flex-col gap-4 justify-start items-center max-w-[650px] bg-white rounded-2xl'>
                <h1 className='text-[2.5rem] font-semibold text-center text-textPrimary font-cormorant'>
                    {isChangePassword ? 'Change Password' : 'Your Profile'}
                </h1>

                {isChangePassword ? (
                    <ChangePassword setIsChangePassword={setIsChangePassword} />
                ) : (
                    <Card className='w-full rounded-xl shadow-2xl border-none py-12 px-20 max-h-[60vh] overflow-y-auto'>
                        <CardContent className='flex flex-col gap-10 p-0'>
                            <div className='flex flex-row gap-6 items-center'>
                                <Avatar className='w-24 h-24 border-[4px] border-white shadow-lg'>
                                    <AvatarImage
                                        className='w-full h-full object-cover rounded-full object-top'
                                        src={imagePreview}
                                        alt={profileValues?.firstName}
                                    />
                                    <AvatarFallback>
                                        {profileValues?.firstName?.charAt(0)}
                                        {profileValues?.lastName?.charAt(0)}
                                    </AvatarFallback>
                                </Avatar>

                                <div className='flex flex-col gap-3'>
                                    <h2 className='text-[1.75rem] font-semibold text-textPrimary font-cormorant'>
                                        {profileValues?.firstName} {profileValues?.lastName}
                                    </h2>
                                    <div className='flex flex-row gap-5 text-sm font-inter'>
                                        <label
                                            htmlFor='profile-picture-input'
                                            className='text-blue hover:underline cursor-pointer'
                                        >
                                            Change picture
                                        </label>
                                        <button
                                            type='button'
                                            className='text-gray500 hover:underline'
                                            onClick={handleDeleteImage}
                                        >
                                            Delete picture
                                        </button>
                                    </div>
                                </div>
                                <input
                                    type='file'
                                    accept='image/png, image/jpeg, image/jpg'
                                    id='profile-picture-input'
                                    className='hidden'
                                    onChange={handleImage}
                                />
                            </div>

                            <form className='space-y-4'>
                                <div className='space-y-2'>
                                    <Label htmlFor='firstName' className='text-sm font-medium text-gray700'>
                                        First Name
                                    </Label>
                                    <Input
                                        id='firstName'
                                        placeholder='First Name'
                                        name='firstName'
                                        value={profileValues?.firstName}
                                        onChange={handleChangeProfile}
                                        className='h-11 border border-gray300'
                                    />
                                    <FieldError error={profileTouched?.firstName && profileErrors?.firstName} />
                                </div>
                                <div className='space-y-2'>
                                    <Label htmlFor='lastName' className='text-sm font-medium text-gray700'>
                                        Last Name
                                    </Label>
                                    <Input
                                        id='lastName'
                                        placeholder='Last Name'
                                        name='lastName'
                                        value={profileValues?.lastName}
                                        onChange={handleChangeProfile}
                                        className='h-11 border border-gray300'
                                    />
                                    <FieldError error={profileTouched?.lastName && profileErrors?.lastName} />
                                </div>
                                {/* <div className='space-y-2'>
                                    <Label htmlFor='businessName' className='text-sm font-medium text-gray700'>
                                        Business Name
                                    </Label>
                                    <Input
                                        id='businessName'
                                        placeholder='Business Name'
                                        name='businessName'
                                        disabled={true}
                                        defaultValue={profileValues?.businessName}
                                    />
                                    <FieldError error={profileTouched?.businessName && profileErrors?.businessName} />
                                </div> */}

                                <div className='space-y-2'>
                                    <Label htmlFor='email' className='text-sm font-medium text-gray700'>
                                        Email
                                    </Label>
                                    <Input
                                        readOnly={true}
                                        id='email'
                                        placeholder='Email'
                                        type='email'
                                        noFocus
                                        defaultValue={profileValues?.email}
                                        className='h-11 border border-gray300 bg-gray50 text-gray500'
                                    />
                                </div>

                                <div className='flex pt-6 justify-end gap-3'>
                                    <Button
                                        variant='default'
                                        onClick={handleSubmitProfile}
                                        disabled={updateProfileApiLoading}
                                        className='bg-textPrimary h-10 text-white text-base font-medium py-[10px] shadow-sm'
                                    >
                                        Save Profile
                                    </Button>
                                    <Button
                                        variant='outline'
                                        onClick={handleChangePassword}
                                        disabled={updateProfileApiLoading}
                                        className='bg-transparent text-gray700 h-10 text-sm font-medium py-[10px] px-[18px] shadow-sm'
                                    >
                                        Change Password
                                    </Button>
                                </div>
                            </form>
                        </CardContent>
                    </Card>
                )}
            </div>
        </div>
    );
};

export { Profile };
